// --------------------------------------------------------------
// Created On: 2026-05-11
// Author: Dimitra Weinstein
//
// Last Modified: 2026-09-02
// Modified By: Dimitra Weinstein
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------
import React, { useState } from "react";
import SampleDeviceDataButton from "../../../../components/SampleDeviceDataButton/SampleDeviceDataButton";
import ValidateAssetButton from "../../../../components/ValidateAssetButton/ValidateAssetButton";
import ValidateAssetModal from "src/components/ValidateAssetButton/ValidateAssetModal/ValidateAssetModal";
import styles from "./AssetDataMobileViewBanner.module.scss";

// Banner containing the SampleDeviceDataButton and ValidateAssetButton that is
// displayed above the product visual and data table when the screen size is in
// mobile view, in the ProductDataVisual component.
export default function AssetDataMobileViewBanner(props: Props): Component {
  const [showValidationModal, setShowValidationModal] = useState<boolean>(false);
  return (
    <div className={styles.assetDataButtonsBanner}>
      <div className="col-12 p-2 d-flex justify-content-end">
        {props.deviceCanSample && props.allowDeviceSample && (
          <SampleDeviceDataButton assetId={props.assetId} className={"mx-2"} smallButton={false} buttonName="Sample" />
        )}
        {props.deviceCanValidate && props.allowAssetValidate && (
          <ValidateAssetButton
            assetId={props.assetId}
            deviceId={props.deviceId || null}
            deviceType={props.deviceType}
            className={"mx-2"}
            smallButton={false}
            onShowValidationModal={() => setShowValidationModal(true)}
          />
        )}
        {showValidationModal && (
          <ValidateAssetModal
            assetId={props.assetId}
            deviceId={props.deviceId}
            deviceType={props.deviceType}
            onClose={() => setShowValidationModal(false)}
          />
        )}
      </div>
    </div>
  );
}

interface Props {
  assetId: number;
  deviceId: number;
  deviceType: string;
  deviceCanSample: boolean;
  deviceCanValidate: boolean;
  allowDeviceSample: boolean;
  allowAssetValidate: boolean;
}
